// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"de301a5b","448":"a1734466","498":"9661646c","768":"c03717eb"}[chunkId] + ".chunk.js";
};